// extracted by mini-css-extract-plugin
export var phone = "_33-0";